import type { SVGProps } from 'react';

const SvgHomeBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M11.4629 4.52734C11.7905 4.31889 12.2095 4.31889 12.5371 4.52734L19.5371 8.98145C19.8255 9.16502 20 9.48335 20 9.8252V19C20 19.5523 19.5523 20 19 20H5C4.44771 20 4 19.5523 4 19V9.8252C4 9.48335 4.17453 9.16502 4.46289 8.98145L11.4629 4.52734Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M8 16H16' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
  </svg>
);
export default SvgHomeBd;
